import * as React from 'react'

export default props => (
  <svg
    width={20}
    height={21}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.104 8.025s-.452 5.613-.715 7.977c-.125 1.13-.822 1.79-1.965 1.812-2.174.039-4.35.041-6.524-.004-1.1-.023-1.785-.693-1.908-1.802-.264-2.385-.714-7.983-.714-7.983M17.257 5.335H3.125M14.534 5.335a1.373 1.373 0 0 1-1.346-1.103l-.203-1.013a1.067 1.067 0 0 0-1.03-.791H8.426c-.483 0-.906.323-1.031.79l-.203 1.014a1.373 1.373 0 0 1-1.345 1.103"
      stroke="#011533"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
